export const ARRAY_DYNAMIC_INTEGRAL_SALARY_WAGE_VALUES = ['year', 'year_variable_type', 'year_variable'];
export const SALARY_CODE = 'SALARY';
export const COLOMBIA_COUNTRY = 'Colombia';
export const MIN_COLOMBIA_SALARY = 1160000;
export const BANK_OTHER_ID = '76324d89-b73b-4a94-8b7b-0b24df6ac8ed';
